import { render, staticRenderFns } from "./personnel_department_change.vue?vue&type=template&id=3ca2d0d8&scoped=true&"
import script from "./personnel_department_change.vue?vue&type=script&lang=js&"
export * from "./personnel_department_change.vue?vue&type=script&lang=js&"
import style0 from "./personnel_department_change.vue?vue&type=style&index=0&id=3ca2d0d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca2d0d8",
  null
  
)

export default component.exports